import {
  Box,
  Button,
  Divider,
  Drawer,
  Snackbar,
  Typography,
} from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useCallback, useMemo, useState } from 'react';
import {
  venueGet,
  venueEdit,
  venuePartEdit,
  venuePartDelete,
  venueDelete,
} from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from '@mui/icons-material/Add';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import { FastField, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { TextField, Select } from 'formik-mui';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useMedia } from 'react-use';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate } from 'react-router-dom';
import ct from 'countries-and-timezones';
import MuiPhoneNumber from 'material-ui-phone-number-2';

export const VenueEdit = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { venueId } = useParams<{ venueId: string }>();
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [venueDeleteConfirmationOpen, setVenueDeleteConfirmationOpen] =
    useState(false);
  const [selected, setSelected] = useState<any | null>(null);
  const isWide = useMedia('(min-width: 900px)');
  const tabsVariant = !isWide ? 'fullWidth' : 'standard';
  const [view, setView] = useState('venue');
  const navigate = useNavigate();
  const countries = ct.getAllCountries();
  const backUrl = '/admin/venues';
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const hasPathParam = !!venueId;
  const queryClient = useQueryClient();

  const tabStyle = {
    minWidth: '0px',
    padding: { xs: '0px', sm: '20px' },
    fontSize: '0.875rem !important',
  };

  const handleViewChange = (event: any, newValue: any) => {
    setView(newValue);
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  const {
    data: response,
    isLoading,
    error,
    refetch,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
  } = useQuery(['venueGet', venueId], venueGet(venueId), {
    enabled: hasPathParam,
    refetchOnWindowFocus: false,
  });

  const data: any = response?.data;
  console.log('data', data);

  const {
    mutateAsync: mutateVenue,
    error: mutateVenueError,
    data: mutateVenueData,
    isLoading: mutateVenueIsLoading,
  } = useMutation('venueEdit', venueEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
    onSettled: () => {
      refetch();
      queryClient.invalidateQueries([
        'venueGet',
        'eventOptionsGet',
        'eventLocationsGet',
      ]);
    },
  });

  const {
    mutateAsync: mutateVenuePart,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation('venuePartEdit', venuePartEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
    onSettled: () => {
      refetch();
      queryClient.invalidateQueries('venueGet', 'eventOptionsGet');
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.venueParts?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: 'name',
        headerName: 'Venue part name',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 2,
        minWidth: 210,
        filter: true,
      },
      {
        field: 'numberOfTotalTickets',
        headerName: 'Total tickets',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        flex: 1,
        minWidth: 70,
      },
      {
        field: 'numberOfHouseTickets',
        headerName: 'House tickets',
        headerClass: 'ag-narrow',
        sortable: true,
        flex: 1,
        minWidth: 70,
      },
      {
        field: 'numberOfWheelchairTickets',
        headerName: 'Wheelchair tickets',
        sortable: true,
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        flex: 1,
        minWidth: 70,
      },
    ];

    return { columnDefs, rowData: data.venueParts };
  }, [data]);

  const handlePhone1Change = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: 'phone1', value } });
    },
    [],
  );

  const handlePhone2Change = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: 'phone2', value } });
    },
    [],
  );

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };

  console.log('selectedOrganization----', selectedOrganization);

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        message="Saved. You can now add parts."
      />
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit venue part' : 'Add venue part'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              <Box
                sx={{
                  mb: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    Organization:{' '}
                  </Typography>
                  {selectedOrganization?.name}
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    Venue:{' '}
                  </Typography>
                  {data?.name}
                </Box>
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the organization.'}
              */}

              <Formik
                validateOnMount
                initialValues={
                  selected || {
                    name: '',
                    numberOfTotalTickets: null,
                    numberOfHouseTickets: null,
                    numberOfWheelchairTickets: null,
                  }
                }
                validationSchema={Yup.object().shape({
                  name: Yup.string().required('Required'),
                  numberOfTotalTickets: Yup.number().required('Required'),
                })}
                onSubmit={async (values: any, { setSubmitting }) => {
                  values.organizationId = selectedOrganization.id;
                  values.venueId = data.id;
                  try {
                    await mutateVenuePart({ values });
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form style={{ width: '100%' }}>
                    <Box
                      sx={{
                        width: '100%',
                        marginInline: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        position: 'relative',
                      }}
                    >
                      <FastField
                        component={TextField}
                        label="Name"
                        name="name"
                        size="small"
                      />

                      <FastField
                        component={TextField}
                        label="Total number of tickets"
                        name="numberOfTotalTickets"
                        type="number"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Number of house tickets"
                        name="numberOfHouseTickets"
                        type="number"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Number of wheelchair tickets"
                        name="numberOfWheelchairTickets"
                        type="number"
                        size="small"
                      />

                      <Box
                        sx={{
                          textAlign: 'right',
                          margin: '16px 0',
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => setRightDrawerOpen(false)}
                          sx={{ padding: '6px 8px' }}
                        >
                          Cancel
                        </Button>

                        <Box sx={{ flex: '1 1 auto' }} />
                        {!!selected && (
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            onClick={() => setDialogOpen(true)}
                            sx={{ padding: '6px 8px' }}
                          >
                            Delete
                          </Button>
                        )}
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: '6px 24px' }}
                          onClick={submitForm}
                        >
                          {!!selected ? 'Save' : 'Add'}
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The venue part will not be deleted if it is used by a future ending event.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await venuePartDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={venueDeleteConfirmationOpen}
        onClose={() => setVenueDeleteConfirmationOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The venue will not be deleted if a part of it is used by a future ending event.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVenueDeleteConfirmationOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              try {
                const response = await venueDelete(venueId as string)();
                setVenueDeleteConfirmationOpen(false);
                if (response) {
                  navigate(backUrl);
                  setVenueDeleteConfirmationOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                setVenueDeleteConfirmationOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0,
            flexGrow: 0,
            alignItems: 'center',
            gap: '5px 6px',
            minHeight: '56px',
            maxWidth: '100vw',
            flexWrap: 'wrap',
            padding: '8px 0 8px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
            }}
          >
            {!!data?.name ? data.name : 'Add venue'}
          </Typography>
          {((!isWide && view === 'venueParts' && !!hasPathParam) ||
            (!!isWide && !!hasPathParam)) && (
            <Button
              color="primary"
              onClick={() => {
                setSelected(null);
                setRightDrawerOpen(true);
              }}
            >
              <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
              Add part
            </Button>
          )}
        </Box>
        {!isWide && (
          <Box>
            <Tabs
              value={view}
              onChange={handleViewChange}
              textColor="primary"
              indicatorColor="primary"
              variant={tabsVariant}
              aria-label="secondary tabs"
              sx={{ mt: '-4px' }}
            >
              <Tab sx={tabStyle} value="venue" label="Venue" />
              <Tab
                sx={tabStyle}
                value="venueParts"
                label="Parts"
                disabled={!venueId}
              />
            </Tabs>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            gap: '32px',
            mb: '-16px',
          }}
        >
          {((!isWide && view === 'venue' && (!hasPathParam || data)) ||
            (!!isWide && (!hasPathParam || data))) && (
            <Box
              sx={{
                position: 'relative',
                padding: '16px 16px 0',
                margin: '0 -16px -16px',
                maxWidth: !!isWide ? '420px' : 'auto',
                maxHeight: !!isWide
                  ? 'calc(100vh - 115px)'
                  : 'calc(100vh - 115px - 48px + 16px)',
                height: '100%',
                width: 'calc(100% + 32px)',
                overflowY: 'auto',
              }}
            >
              <Formik
                validateOnMount
                initialValues={
                  data || {
                    name: '',
                    ticketMessage: '',
                    phone1: '',
                    phone2: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    country: '',
                    timezone: '',
                    latitude: '',
                    longitude: '',
                  }
                }
                validationSchema={Yup.object().shape({
                  name: Yup.string().required('Required'),
                  country: Yup.string().required('Required'),
                })}
                onSubmit={async (values: any, { setSubmitting }) => {
                  values.organizationId = selectedOrganization.id;
                  try {
                    const response = await mutateVenue({ values });
                    const venueId = response.data.id;

                    if (hasPathParam) {
                      navigate(backUrl);
                    } else {
                      navigate(`/admin/venue-edit/${venueId}`);
                    }
                  } catch (error: any) {
                    alert(error.error, error.message);
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form style={{ width: '100%' }}>
                    <Box
                      sx={{
                        width: '100%',
                        marginInline: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        position: 'relative',
                      }}
                    >
                      <FastField
                        component={TextField}
                        label="Name"
                        name="name"
                        size="small"
                      />
                      <Box className="small-formik-select-fix">
                        <FastField
                          component={Select}
                          label="Country"
                          id="country"
                          name="country"
                          size="small"
                          required
                        >
                          {!!countries &&
                            Object.keys(countries).map((c) => (
                              <MenuItem
                                key={countries[c]?.id}
                                value={countries[c]?.name}
                              >
                                {countries[c]?.name}
                              </MenuItem>
                            ))}
                        </FastField>
                      </Box>
                      <FastField
                        component={TextField}
                        label="Postal code"
                        name="postalCode"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="State"
                        name="state"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="City"
                        name="city"
                        size="small"
                      />
                      <FastField
                        component={TextField}
                        label="Street address"
                        name="streetAddress"
                        size="small"
                      />
                      <MuiPhoneNumber
                        required
                        size="small"
                        defaultCountry={'rw'}
                        name="phone1"
                        label="Phone 1"
                        variant="outlined"
                        value={values.phone}
                        onBlur={handleBlur}
                        onChange={handlePhone1Change(handleChange)}
                        error={touched.phone && !!errors.phone}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        helperText={touched.phone && errors.phone}
                        className="MuiPhoneNumber"
                        InputLabelProps={{ required: false }}
                      />
                      <MuiPhoneNumber
                        required
                        size="small"
                        defaultCountry={'rw'}
                        name="phone2"
                        label="Phone 2"
                        variant="outlined"
                        value={values.phone}
                        onBlur={handleBlur}
                        onChange={handlePhone2Change(handleChange)}
                        error={touched.phone && !!errors.phone}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        helperText={touched.phone && errors.phone}
                        className="MuiPhoneNumber"
                        InputLabelProps={{ required: false }}
                      />
                      <FastField
                        component={TextField}
                        label="Timezone"
                        name="timezone"
                        size="small"
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: 1.5,
                          width: '100%',
                        }}
                      >
                        <FastField
                          component={TextField}
                          label="Latitude"
                          name="latitude"
                          size="small"
                          type="number"
                          sx={{ flexGrow: 1 }}
                        />
                        <FastField
                          component={TextField}
                          label="Longitude"
                          name="longitude"
                          size="small"
                          type="number"
                          sx={{ flexGrow: 1 }}
                        />
                      </Box>
                      <FastField
                        component={TextField}
                        label="Ticket message"
                        name="ticketMessage"
                        size="small"
                      />

                      {!!data &&
                        selectedOrganization?.type === 'cinema' &&
                        (selectedOrganization?.dataSource === 'VEEZI_EU' ||
                          selectedOrganization?.dataSource === 'VEEZI_US') && (
                          <Typography>
                            Veezi imported venue data (except the coordinates)
                            will be overridden with the values from the Veezi
                            site.
                          </Typography>
                        )}

                      <Box
                        sx={{
                          textAlign: 'right',
                          margin: '16px 0',
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => {
                            navigate(backUrl);
                          }}
                          sx={{ padding: '6px 8px' }}
                        >
                          Back
                        </Button>

                        <Box sx={{ flex: '1 1 auto' }} />
                        {!!data && (
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            onClick={() => setVenueDeleteConfirmationOpen(true)}
                            sx={{ padding: '6px 8px' }}
                          >
                            Delete
                          </Button>
                        )}
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: '6px 24px' }}
                          onClick={() => {
                            setSnackbarOpen(true);
                            submitForm();
                          }}
                        >
                          {!!hasPathParam ? 'Save' : 'Add'}
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          )}
          {((!isWide && view === 'venueParts' && (!hasPathParam || data)) ||
            (!!isWide && (!hasPathParam || data))) && (
            <Box
              className="ag-theme-material ag-pointer-row"
              sx={{
                borderRadius: 0,
                margin: '0 -16px -16px',
                display: 'flex',
                overflow: 'hidden',
                flexGrow: 1,
                height: '100%',
                boxShadow:
                  'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
              }}
            >
              <AgGridReact
                rowData={rowData}
                pagination={true}
                floatingFiltersHeight={50}
                paginationAutoPageSize={true}
                columnDefs={columnDefs}
                onRowClicked={({ data }) => {
                  setSelected(data);
                  setRightDrawerOpen(true);
                }}
              ></AgGridReact>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
